export default __webpack_public_path__ + "static/media/award.153257e0.svg";